import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';

const textStyle = {
  root: {
    color: '#A80000',
    lineHeight: '24px',
  },
};

export const TitleBarError = ({
  error,
}) => (
  <Text
    block
    nowrap
    variant="medium"
    styles={textStyle}
    title={error}
  >
    {error}
  </Text>
);

TitleBarError.propTypes = {
  error: PropTypes.string.isRequired,
};
